export default {
  init() {
    // JavaScript to be fired on all pages
    $(function () {
      $("[data-toggle='tooltip']").tooltip();

      if ($("body").hasClass("template-portfolio")) {
        $("#template-company").removeClass("active");
        $("#template-portfolio").addClass("active");
      }
      if ($("body").hasClass("template-company")) {
        $("#template-portfolio").removeClass("active");
        $("#template-company").addClass("active");
      }
      if ($(".portfolio-logo").length) {
        $(".portfolio-logo").each(function (i, el) {
          $(el).css(
            "background-image",
            "url('" + $(el).attr("data-image") + "')"
          );
        });
      }
      if ($(".full-portfolio-logo").length) {
        $(".full-portfolio-logo").each(function (i, el) {
          $(el).css(
            "background-image",
            "url('" + $(el).attr("data-image") + "')"
          );
        });
      }
      if ($(".stat-photo-content").length) {
        $(".stat-photo-content").each(function (i, el) {
          $(el).css(
            "background-image",
            "url('" + $(el).attr("data-image") + "')"
          );
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js